// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  /* Color Tokens */
  --technum-navy: #001F3F;
  --technum-steel: #4B5563;
  --technum-teal: #00A896;
  --technum-pearl: #F0F4F8;
  --technum-white: #FFFFFF;

  --technum-success: #059669;
  --technum-warning: #F59E0B;
  --technum-error: #DC2626;

  /* Additional Colors */
  --technum-cream: #FAF7F2;
  --technum-ink: #1F2937;
  --technum-teal-hover: #008573;
  --technum-gray-100: #F3F4F6;
  --technum-gray-200: #E5E7EB;
  --technum-gray-300: #D1D5DB;
  --technum-gray-400: #9CA3AF;
  --technum-accent-light: rgba(0, 168, 150, 0.1);
  --technum-accent-medium: rgba(0, 168, 150, 0.2);
  --technum-overlay-dark: rgba(0, 31, 63, 0.5);
  --technum-gradient-start: #00D4AA;
  --technum-dark-bg: #0A2540;
  --technum-navy-hover: #001533;
  --technum-steel-hover: #3B4653;
  --technum-blue: #3B82F6;
  --technum-cloud-blue: #4A90E2;

  /* Extended Gray Palette */
  --technum-gray-500: #6B7280;
  --technum-gray-600: #4B5563;
  --technum-gray-700: #374151;
  --technum-gray-800: #1F2937;
  --technum-gray-900: #111827;

  /* Semantic Color Aliases */
  --technum-amber: #F59E0B;
  --technum-red: #DC2626;
  --technum-green: #059669;

  /* AWS Partner Colors */
  --technum-aws-orange: #FF9900;
  --technum-aws-orange-light: #FFB84D;
  --technum-aws-orange-dark: #e68a00;
  --technum-aws-dark: #232f3e;
  --technum-aws-navy: #0a1628;
  --technum-aws-mid: #1a2744;

  /* Gradients */
  --technum-gradient-teal: linear-gradient(135deg, #00A896 0%, #007B67 100%);
  --technum-gradient-hero: linear-gradient(
    135deg,
    #001F3F 0%,
    #002A5C 25%,
    #00A896 75%,
    #00C4A7 100%
  );

  /* Typography */
  --font-heading: 'Inter', sans-serif;
  --font-body: 'Roboto', sans-serif;
  --font-code: 'JetBrains Mono', monospace;

  --h1-size: 56px;
  --h2-size: 48px;
  --h3-size: 36px;
  --h4-size: 28px;
  --h5-size: 22px;
  --body-large: 18px;
  --body-regular: 16px;
  --body-small: 14px;
  --caption: 12px;
  --btn-size: 16px;
  --container-padding: 24px;
  --section-padding: 80px;

  --line-height-h1: 1.1;
  --line-height-h2: 1.2;
  --line-height-h3: 1.3;

  /* Spacing */
  --space-xxs: 2px;
  --space-xs: 4px;
  --space-sm: 8px;
  --space-md: 16px;
  --space-lg: 24px;
  --space-xl: 40px;
  --space-xxl: 64px;
  --technum-space-xs: 4px;
  --technum-space-sm: 8px;
  --technum-space-md: 16px;
  --technum-space-lg: 24px;
  --technum-space-xl: 32px;
  --technum-space-2xl: 48px;
  --technum-space-3xl: 64px;

  /* Border Radius */
  --radius-sm: 4px;
  --radius-md: 8px;
  --radius-lg: 16px;
  --radius-xl: 20px;
  --radius-pill: 9999px;
  --radius-circle: 50%;
  --technum-radius-sm: 4px;
  --technum-radius-md: 8px;
  --technum-radius-lg: 12px;
  --technum-radius-xl: 16px;
  --technum-radius-2xl: 24px;
  --technum-radius-full: 9999px;

  /* Shadows */
  --shadow-sm: 0 1px 2px rgba(0, 0, 0, 0.05);
  --shadow-md: 0 4px 6px rgba(0, 0, 0, 0.1);
  --shadow-lg: 0 8px 24px rgba(0, 0, 0, 0.15);
  --shadow-xl: 0 12px 48px rgba(0, 0, 0, 0.2);

  /* Homepage Shadow Variants */
  --technum-shadow-sm: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  --technum-shadow-md: 0 4px 6px -1px rgba(0, 0, 0, 0.1),
    0 2px 4px -1px rgba(0, 0, 0, 0.06);
  --technum-shadow-lg: 0 10px 15px -3px rgba(0, 0, 0, 0.1),
    0 4px 6px -2px rgba(210, 55, 55, 0.05);
  --technum-shadow-xl: 0 20px 25px -5px rgba(0, 0, 0, 0.1),
    0 10px 10px -5px rgba(0, 0, 0, 0.04);

  /* Transitions */
  --transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  --transition-slow: all 0.6s cubic-bezier(0.4, 0, 0.2, 1);
  --transition-fast: all 0.2s ease;
}

/* Global Page Styles */
body {
  font-family: var(--font-body);
  line-height: 1.6;
  color: var(--technum-steel);
  background-color: var(--technum-pearl);
  scroll-behavior: smooth;
  min-height: 100vh;
  overflow-x: hidden;
}

/* Eliminate trailing whitespace between the last page section and the footer */
.technumopus-main {
  margin-bottom: 0;
  padding-bottom: 0;
}

.technumopus-main > div,
.technumopus-main > div > main {
  margin-bottom: 0;
  padding-bottom: 0;
}

.technumopus-main > div > section:last-of-type,
.technumopus-main > div > main > section:last-of-type {
  margin-bottom: 0;
}

/* Common Components */

/* Container */
.technum-container {
  max-width: 1440px;
  margin: 0 auto;
  padding: 0 var(--container-padding);
}

/* Breadcrumb */
.technum-breadcrumb {
  background: var(--technum-white);
  padding: var(--space-sm) 0;
  border-bottom: 1px solid var(--technum-gray-200);
}

.technum-breadcrumb-nav {
  display: flex;
  align-items: center;
  gap: var(--space-sm);
  font-size: var(--body-small);
}

.technum-breadcrumb-nav a {
  color: var(--technum-steel);
  text-decoration: none;
  transition: var(--transition);
  position: relative;
}

.technum-breadcrumb-nav a::after {
  content: '';
  position: absolute;
  bottom: -2px;
  left: 0;
  width: 0;
  height: 2px;
  background: var(--technum-teal);
  transition: var(--transition);
}

.technum-breadcrumb-nav a:hover {
  color: var(--technum-teal);
}

.technum-breadcrumb-nav a:hover::after {
  width: 100%;
}

.technum-breadcrumb-nav span {
  color: var(--technum-navy);
  font-weight: 600;
}

/* Buttons */
.technum-btn-primary {
  background: var(--technum-teal);
  color: var(--technum-white);
  padding: var(--space-sm) var(--space-lg);
  border: none;
  border-radius: var(--radius-md);
  font-family: var(--font-heading);
  font-weight: 600;
  font-size: var(--body-regular);
  text-decoration: none;
  transition: var(--transition);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.technum-btn-primary::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 0;
  height: 0;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.2);
  transform: translate(-50%, -50%);
  transition: width 0.6s, height 0.6s;
}

.technum-btn-primary:hover::before {
  width: 300px;
  height: 300px;
}

.technum-btn-primary:hover {
  background: var(--technum-teal-hover);
  transform: translateY(-2px);
  box-shadow: 0 8px 20px var(--technum-accent-medium);
}

.technum-btn-secondary {
  background: var(--technum-white);
  color: var(--technum-navy);
  padding: var(--space-sm) var(--space-lg);
  border: 2px solid var(--technum-navy);
  border-radius: var(--radius-md);
  font-family: var(--font-heading);
  font-weight: 600;
  font-size: var(--body-regular);
  text-decoration: none;
  transition: var(--transition);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.technum-btn-secondary:hover {
  background: var(--technum-pearl);
  transform: translateY(-2px);
  box-shadow: var(--shadow-sm);
}

.technum-btn-ghost {
  background: transparent;
  color: var(--technum-teal);
  padding: var(--space-sm) var(--space-lg);
  border: 2px solid var(--technum-teal);
  border-radius: var(--radius-md);
  font-family: var(--font-heading);
  font-weight: 600;
  font-size: var(--body-regular);
  text-decoration: none;
  transition: var(--transition);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.technum-btn-ghost:hover {
  background: var(--technum-accent-light);
  transform: translateY(-2px);
  box-shadow: var(--shadow-sm);
}

.technum-btn-filter {
  background: var(--technum-pearl);
  color: var(--technum-steel);
  padding: var(--space-sm) var(--space-lg);
  border: 2px solid transparent;
  border-radius: var(--radius-pill);
  font-family: var(--font-heading);
  font-weight: 500;
  font-size: var(--body-small);
  transition: var(--transition);
  cursor: pointer;
}

.technum-btn-filter:hover,
.technum-btn-filter.active {
  background: var(--technum-teal);
  color: var(--technum-white);
  border-color: var(--technum-teal);
}

/* Hero Sections */
.technum-hero {
  padding: var(--section-padding) 0;
  position: relative;
  overflow: hidden;
  text-align: center;
}

.technum-hero-content {
  position: relative;
  z-index: 2;
  max-width: 900px;
  margin: 0 auto;
}

.technum-hero h1 {
  font-family: var(--font-heading);
  font-weight: 700;
  font-size: var(--h1-size);
  margin-bottom: var(--space-lg);
  line-height: var(--line-height-h1);
  letter-spacing: -0.02em;
}

.technum-hero p {
  font-size: var(--body-large);
  max-width: 700px;
  margin: 0 auto var(--space-xl);
  line-height: 1.7;
}

.technum-hero-buttons {
  display: flex;
  gap: var(--space-md);
  flex-wrap: wrap;
  justify-content: center;
}

/* Hero Type 1: Gradient Background */
.technum-hero-gradient {
  background: linear-gradient(135deg, var(--technum-navy) 0%, var(--technum-teal) 100%);
  color: var(--technum-white);
}

.technum-hero-gradient h1,
.technum-hero-gradient p {
  color: var(--technum-white);
}

.technum-hero-gradient::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: radial-gradient(circle at 20% 50%, var(--technum-accent-light) 0%, transparent 50%);
  opacity: 0.6;
}

/* Hero Type 2: Image Background */
.technum-hero-image {
  background-size: cover;
  background-position: center;
  color: var(--technum-white);
}

.technum-hero-image::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: var(--technum-overlay-dark);
}

.technum-hero-image h1,
.technum-hero-image p {
  color: var(--technum-white);
}

/* Card Sections */
.technum-card {
  background: var(--technum-white);
  border: 1px solid var(--technum-gray-200);
  border-radius: var(--radius-lg);
  padding: var(--space-xl);
  transition: var(--transition);
  position: relative;
  overflow: hidden;
}

.technum-card:hover {
  border-color: var(--technum-teal);
  transform: translateY(-4px);
  box-shadow: var(--shadow-lg);
}

.technum-card h3 {
  font-family: var(--font-heading);
  font-weight: 600;
  font-size: var(--h4-size);
  color: var(--technum-navy);
  margin-bottom: var(--space-md);
}

.technum-card p {
  font-size: var(--body-regular);
  color: var(--technum-steel);
  line-height: 1.7;
}

/* Card Type 1: Icon Feature Card (e.g., benefits, culture) */
.technum-card-feature {
  text-align: center;
}

.technum-card-feature-icon {
  width: 64px;
  height: 64px;
  background: var(--technum-accent-light);
  border: 2px solid var(--technum-teal);
  border-radius: var(--radius-md);
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto var(--space-lg);
  color: var(--technum-teal);
  transition: var(--transition);
  font-size: 32px;
}

.technum-card-feature:hover .technum-card-feature-icon {
  background: var(--technum-teal);
  color: var(--technum-white);
  transform: scale(1.05) rotate(5deg);
}

/* Dark variant for feature card */
.technum-card-feature-dark {
  background: var(--technum-accent-medium);
  color: var(--technum-white);
  border-color: var(--technum-accent-medium);
}

.technum-card-feature-dark h3 {
  color: var(--technum-white);
}

.technum-card-feature-dark p {
  color: rgba(255, 255, 255, 0.9);
}

.technum-card-feature-dark .technum-card-feature-icon {
  background: rgba(255, 255, 255, 0.1);
  border-color: rgba(255, 255, 255, 0.3);
  color: var(--technum-white);
}

.technum-card-feature-dark:hover .technum-card-feature-icon {
  background: var(--technum-teal);
  border-color: var(--technum-teal);
}

/* Card Type 2: Metric/Stat Card */
.technum-card-metric {
  text-align: center;
  padding: var(--space-lg);
}

.technum-card-metric-icon {
  width: 80px;
  height: 80px;
  background: linear-gradient(135deg, var(--technum-teal), var(--technum-navy));
  border-radius: var(--radius-circle);
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto var(--space-lg);
  color: var(--technum-white);
  font-size: 40px;
}

.technum-card-metric-value {
  font-family: var(--font-heading);
  font-weight: 700;
  font-size: 32px;
  color: var(--technum-teal);
  margin-bottom: var(--space-sm);
}

.technum-card-metric-label {
  font-size: var(--body-small);
  color: var(--technum-steel);
  font-weight: 500;
}

.technum-card-metric-description {
  font-size: var(--body-small);
  color: var(--technum-steel);
  opacity: 0.8;
  margin-top: var(--space-xs);
}

/* Card Type 3: Content Card with Image/Gradient Header */
.technum-card-content {
  overflow: hidden;
}

.technum-card-content-header {
  width: 100%;
  height: 200px;
  background: linear-gradient(135deg, var(--technum-teal), var(--technum-navy));
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  transition: var(--transition);
}

.technum-card-content-header::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(45deg, transparent 30%, rgba(255,255,255,0.1) 50%, transparent 70%);
  transform: translateX(-100%);
  transition: transform 0.6s ease;
}

.technum-card-content:hover .technum-card-content-header::after {
  transform: translateX(100%);
}

.technum-card-content-header-icon {
  width: 80px;
  height: 80px;
  color: var(--technum-white);
  opacity: 0.9;
}

.technum-card-content-body {
  padding: var(--space-lg);
}

.technum-card-content-meta {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: var(--space-sm);
  font-size: var(--caption);
  color: var(--technum-steel);
}

.technum-card-content-category {
  background: var(--technum-pearl);
  padding: var(--space-xs) var(--space-sm);
  border-radius: var(--radius-md);
  font-weight: 500;
}

/* Sections */
.technum-section {
  padding: var(--section-padding) 0;
}

.technum-section-header {
  text-align: center;
  margin-bottom: var(--space-xxl);
}

.technum-section-header h2 {
  font-family: var(--font-heading);
  font-weight: 600;
  font-size: var(--h2-size);
  color: var(--technum-navy);
  margin-bottom: var(--space-md);
  letter-spacing: -0.01em;
}

.technum-section-header p {
  font-size: var(--body-large);
  color: var(--technum-steel);
  max-width: 720px;
  margin: 0 auto;
  line-height: 1.7;
}

/* Dark section variant */
.technum-section-dark {
  background: var(--technum-dark-bg);
  color: var(--technum-white);
}

.technum-section-dark .technum-section-header h2 {
  color: var(--technum-white);
}

.technum-section-dark .technum-section-header p {
  color: rgba(255, 255, 255, 0.9);
}

/* Grid Layouts */
.technum-grid-2 {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: var(--space-xl);
}

.technum-grid-3 {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: var(--space-lg);
}

.technum-grid-4 {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: var(--space-md);
}

.technum-grid-auto {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: var(--space-lg);
}

/* Form Elements (Generic) */
.technum-form-group {
  margin-bottom: var(--space-lg);
}

.technum-form-group label {
  display: block;
  margin-bottom: var(--space-sm);
  font-family: var(--font-heading);
  font-weight: 500;
  color: var(--technum-navy);
  font-size: var(--body-small);
}

.technum-form-group input,
.technum-form-group select,
.technum-form-group textarea {
  width: 100%;
  padding: var(--space-sm) var(--space-md);
  border: 2px solid var(--technum-gray-200);
  border-radius: var(--radius-md);
  font-family: var(--font-body);
  font-size: var(--body-regular);
  transition: var(--transition);
  background: var(--technum-white);
  box-sizing: border-box;
}

.technum-form-group input:focus,
.technum-form-group select:focus,
.technum-form-group textarea:focus {
  outline: none;
  border-color: var(--technum-teal);
  box-shadow: 0 0 0 4px var(--technum-accent-light);
}

.technum-form-group textarea {
  min-height: 120px;
  resize: vertical;
}

/* Search Input */
.technum-search-input {
  display: flex;
  align-items: center;
  background: var(--technum-pearl);
  padding: var(--space-sm) var(--space-md);
  border-radius: var(--radius-md);
  border: 2px solid transparent;
  transition: var(--transition);
  max-width: 300px;
}

.technum-search-input:focus-within {
  border-color: var(--technum-teal);
}

.technum-search-input input {
  background: none;
  border: none;
  outline: none;
  font-family: var(--font-body);
  font-size: var(--body-regular);
  color: var(--technum-steel);
  flex: 1 1;
  margin-left: var(--space-sm);
}

.technum-search-input input::placeholder {
  color: var(--technum-gray-400);
}

/* Tags and Badges */
.technum-tag {
  display: inline-flex;
  align-items: center;
  padding: var(--space-xs) var(--space-sm);
  border-radius: var(--radius-pill);
  font-size: var(--caption);
  font-weight: 500;
  background: var(--technum-pearl);
  color: var(--technum-steel);
}

.technum-tag-primary {
  background: var(--technum-teal);
  color: var(--technum-white);
}

.technum-tag-warning {
  background: var(--technum-accent-light);
  color: var(--technum-warning);
}

.technum-tag-success {
  background: var(--technum-success);
  color: var(--technum-white);
}

.technum-badge {
  display: inline-flex;
  align-items: center;
  padding: 6px 16px;
  border-radius: var(--radius-pill);
  font-size: var(--caption);
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.technum-badge-primary {
  background: var(--technum-teal);
  color: var(--technum-white);
}

.technum-badge-light {
  background: var(--technum-accent-medium);
  color: var(--technum-white);
}

/* Icons (Common styles) */
.technum-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: var(--technum-teal);
  transition: var(--transition);
}

.technum-icon-small {
  font-size: 16px;
}

.technum-icon-medium {
  font-size: 24px;
}

.technum-icon-large {
  font-size: 40px;
}

.technum-icon-circle {
  background: var(--technum-accent-light);
  border-radius: var(--radius-circle);
  padding: var(--space-xs);
}

.technum-icon-rounded {
  background: var(--technum-teal);
  color: var(--technum-white);
  border-radius: var(--radius-md);
  padding: var(--space-sm);
}

.technum-icon:hover {
  transform: scale(1.1);
}

/* Read More Link */
.technum-read-more {
  color: var(--technum-teal);
  text-decoration: none;
  font-family: var(--font-heading);
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  gap: var(--space-sm);
  transition: var(--transition);
}

.technum-read-more:hover {
  color: var(--technum-teal-hover);
  gap: var(--space-md);
}

/* Animations */
@keyframes technum-fade-in {
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: translateY(0); }
}

.technum-animate-fade {
  animation: technum-fade-in var(--transition-slow);
}

/* ── Responsive Typography & Spacing Variables ── */
@media (max-width: 1024px) {
  :root {
    --h1-size: 44px;
    --h2-size: 36px;
    --h3-size: 28px;
    --h4-size: 24px;
    --h5-size: 20px;
    --body-large: 16px;
    --body-regular: 15px;
    --body-small: 14px;
    --btn-size: 14px;
    --container-padding: 20px;
    --section-padding: 64px;
  }
}

@media (max-width: 768px) {
  :root {
    --h1-size: 36px;
    --h2-size: 30px;
    --h3-size: 24px;
    --h4-size: 20px;
    --h5-size: 18px;
    --body-large: 15px;
    --body-regular: 14px;
    --body-small: 13px;
    --btn-size: 13px;
    --container-padding: 16px;
    --section-padding: 48px;
  }
}

@media (max-width: 480px) {
  :root {
    --h1-size: 28px;
    --h2-size: 24px;
    --h3-size: 20px;
    --h4-size: 18px;
    --h5-size: 16px;
    --body-large: 14px;
    --body-regular: 14px;
    --body-small: 13px;
    --btn-size: 12px;
    --container-padding: 14px;
    --section-padding: 36px;
  }
}

@media (max-width: 360px) {
  :root {
    --h1-size: 24px;
    --h2-size: 22px;
    --h3-size: 18px;
    --h4-size: 16px;
    --h5-size: 14px;
    --body-large: 14px;
    --body-regular: 13px;
    --body-small: 12px;
    --btn-size: 12px;
    --container-padding: 12px;
    --section-padding: 28px;
  }
}

/* Responsiveness */
@media (max-width: 1100px) {
  .technum-hero h1 {
    font-size: var(--h1-size);
  }

  .technum-grid-4 {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 900px) {
  .technum-grid-2,
  .technum-grid-3 {
    grid-template-columns: 1fr;
  }

  .technum-form-grid {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 720px) {
  .technum-section {
    padding: var(--section-padding) 0;
  }

  .technum-hero {
    padding: var(--space-xl) 0;
  }

  .technum-hero h1,
  .technum-section-header h2 {
    font-size: var(--h2-size);
  }

  .technum-grid-4 {
    grid-template-columns: 1fr;
  }

  .technum-container {
    padding: 0 var(--container-padding);
  }
}

/* ---------- Touch Device: disable hover transforms ---------- */
@media (hover: none) {
  .technum-btn-primary:hover,
  .technum-btn-secondary:hover,
  .technum-btn-ghost:hover,
  .technum-card:hover,
  .technum-icon:hover {
    transform: none;
  }

  .technum-card-feature:hover .technum-card-feature-icon {
    transform: none;
  }
}

/* ---------- Reduced Motion: respect user preference ---------- */
@media (prefers-reduced-motion: reduce) {
  *,
  *::before,
  *::after {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
    scroll-behavior: auto !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/Technum.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,uBAAuB;EACvB,wBAAwB;EACxB,uBAAuB;EACvB,wBAAwB;EACxB,wBAAwB;;EAExB,0BAA0B;EAC1B,0BAA0B;EAC1B,wBAAwB;;EAExB,sBAAsB;EACtB,wBAAwB;EACxB,sBAAsB;EACtB,6BAA6B;EAC7B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,8CAA8C;EAC9C,+CAA+C;EAC/C,4CAA4C;EAC5C,iCAAiC;EACjC,0BAA0B;EAC1B,6BAA6B;EAC7B,8BAA8B;EAC9B,uBAAuB;EACvB,6BAA6B;;EAE7B,0BAA0B;EAC1B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;;EAE3B,2BAA2B;EAC3B,wBAAwB;EACxB,sBAAsB;EACtB,wBAAwB;;EAExB,uBAAuB;EACvB,6BAA6B;EAC7B,mCAAmC;EACnC,kCAAkC;EAClC,2BAA2B;EAC3B,2BAA2B;EAC3B,0BAA0B;;EAE1B,cAAc;EACd,0EAA0E;EAC1E;;;;;;GAMC;;EAED,eAAe;EACf,mCAAmC;EACnC,iCAAiC;EACjC,wCAAwC;;EAExC,eAAe;EACf,eAAe;EACf,eAAe;EACf,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,uBAAuB;;EAEvB,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;;EAErB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,uBAAuB;EACvB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,yBAAyB;EACzB,yBAAyB;;EAEzB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,qBAAqB;EACrB,oBAAoB;EACpB,wBAAwB;EACxB,wBAAwB;EACxB,yBAAyB;EACzB,yBAAyB;EACzB,0BAA0B;EAC1B,6BAA6B;;EAE7B,YAAY;EACZ,0CAA0C;EAC1C,yCAAyC;EACzC,2CAA2C;EAC3C,2CAA2C;;EAE3C,6BAA6B;EAC7B,oDAAoD;EACpD;sCACoC;EACpC;0CACwC;EACxC;wCACsC;;EAEtC,gBAAgB;EAChB,mDAAmD;EACnD,wDAAwD;EACxD,gCAAgC;AAClC;;AAEA,uBAAuB;AACvB;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,2BAA2B;EAC3B,sCAAsC;EACtC,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,+EAA+E;AAC/E;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;;EAEE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA,sBAAsB;;AAEtB,cAAc;AACd;EACE,iBAAiB;EACjB,cAAc;EACd,mCAAmC;AACrC;;AAEA,eAAe;AACf;EACE,gCAAgC;EAChC,0BAA0B;EAC1B,gDAAgD;AAClD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;EAC3B,qBAAqB;EACrB,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,QAAQ;EACR,WAAW;EACX,+BAA+B;EAC/B,6BAA6B;AAC/B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA,YAAY;AACZ;EACE,+BAA+B;EAC/B,2BAA2B;EAC3B,wCAAwC;EACxC,YAAY;EACZ,+BAA+B;EAC/B,gCAAgC;EAChC,gBAAgB;EAChB,8BAA8B;EAC9B,qBAAqB;EACrB,6BAA6B;EAC7B,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,QAAQ;EACR,SAAS;EACT,kBAAkB;EAClB,oCAAoC;EACpC,gCAAgC;EAChC,mCAAmC;AACrC;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,mDAAmD;AACrD;;AAEA;EACE,gCAAgC;EAChC,0BAA0B;EAC1B,wCAAwC;EACxC,qCAAqC;EACrC,+BAA+B;EAC/B,gCAAgC;EAChC,gBAAgB;EAChB,8BAA8B;EAC9B,qBAAqB;EACrB,6BAA6B;EAC7B,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,gCAAgC;EAChC,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,uBAAuB;EACvB,0BAA0B;EAC1B,wCAAwC;EACxC,qCAAqC;EACrC,+BAA+B;EAC/B,gCAAgC;EAChC,gBAAgB;EAChB,8BAA8B;EAC9B,qBAAqB;EACrB,6BAA6B;EAC7B,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,uCAAuC;EACvC,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,gCAAgC;EAChC,2BAA2B;EAC3B,wCAAwC;EACxC,6BAA6B;EAC7B,iCAAiC;EACjC,gCAAgC;EAChC,gBAAgB;EAChB,4BAA4B;EAC5B,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;;EAEE,+BAA+B;EAC/B,2BAA2B;EAC3B,iCAAiC;AACnC;;AAEA,kBAAkB;AAClB;EACE,iCAAiC;EACjC,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,yBAAyB;EACzB,8BAA8B;EAC9B,kCAAkC;EAClC,uBAAuB;AACzB;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,eAAe;EACf,uBAAuB;AACzB;;AAEA,qCAAqC;AACrC;EACE,qFAAqF;EACrF,2BAA2B;AAC7B;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,+FAA+F;EAC/F,YAAY;AACd;;AAEA,kCAAkC;AAClC;EACE,sBAAsB;EACtB,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,uCAAuC;AACzC;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA,kBAAkB;AAClB;EACE,gCAAgC;EAChC,yCAAyC;EACzC,+BAA+B;EAC/B,wBAAwB;EACxB,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,yBAAyB;EACzB,0BAA0B;EAC1B,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA,6DAA6D;AAC7D;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,uCAAuC;EACvC,qCAAqC;EACrC,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,8BAA8B;EAC9B,0BAA0B;EAC1B,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,+BAA+B;EAC/B,2BAA2B;EAC3B,mCAAmC;AACrC;;AAEA,kCAAkC;AAClC;EACE,wCAAwC;EACxC,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;EACtC,2BAA2B;AAC7B;;AAEA;EACE,+BAA+B;EAC/B,iCAAiC;AACnC;;AAEA,kCAAkC;AAClC;EACE,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,6EAA6E;EAC7E,mCAAmC;EACnC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,8BAA8B;EAC9B,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,0BAA0B;EAC1B,8BAA8B;AAChC;;AAEA;EACE,4BAA4B;EAC5B,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,2BAA2B;EAC3B,YAAY;EACZ,2BAA2B;AAC7B;;AAEA,yDAAyD;AACzD;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,6EAA6E;EAC7E,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,+FAA+F;EAC/F,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,YAAY;AACd;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,8BAA8B;EAC9B,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;EAChC,wCAAwC;EACxC,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA,aAAa;AACb;EACE,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,yBAAyB;EACzB,0BAA0B;EAC1B,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,4BAA4B;EAC5B,2BAA2B;EAC3B,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA,yBAAyB;AACzB;EACE,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,+BAA+B;AACjC;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,qCAAqC;EACrC,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,oBAAoB;AACtB;;AAEA,4BAA4B;AAC5B;EACE,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,8BAA8B;EAC9B,gCAAgC;EAChC,gBAAgB;EAChB,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;;;EAGE,WAAW;EACX,wCAAwC;EACxC,yCAAyC;EACzC,+BAA+B;EAC/B,6BAA6B;EAC7B,8BAA8B;EAC9B,6BAA6B;EAC7B,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;;;EAGE,aAAa;EACb,iCAAiC;EACjC,iDAAiD;AACnD;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,mBAAmB;EACnB,gCAAgC;EAChC,wCAAwC;EACxC,+BAA+B;EAC/B,6BAA6B;EAC7B,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,6BAA6B;EAC7B,8BAA8B;EAC9B,2BAA2B;EAC3B,SAAO;EACP,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;AAChC;;AAEA,oBAAoB;AACpB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,wCAAwC;EACxC,iCAAiC;EACjC,yBAAyB;EACzB,gBAAgB;EAChB,gCAAgC;EAChC,2BAA2B;AAC7B;;AAEA;EACE,+BAA+B;EAC/B,2BAA2B;AAC7B;;AAEA;EACE,uCAAuC;EACvC,6BAA6B;AAC/B;;AAEA;EACE,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,iCAAiC;EACjC,yBAAyB;EACzB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,+BAA+B;EAC/B,2BAA2B;AAC7B;;AAEA;EACE,wCAAwC;EACxC,2BAA2B;AAC7B;;AAEA,0BAA0B;AAC1B;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,uCAAuC;EACvC,mCAAmC;EACnC,wBAAwB;AAC1B;;AAEA;EACE,+BAA+B;EAC/B,2BAA2B;EAC3B,+BAA+B;EAC/B,wBAAwB;AAC1B;;AAEA;EACE,qBAAqB;AACvB;;AAEA,mBAAmB;AACnB;EACE,0BAA0B;EAC1B,qBAAqB;EACrB,gCAAgC;EAChC,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;EACE,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA,eAAe;AACf;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA;EACE,iDAAiD;AACnD;;AAEA,oDAAoD;AACpD;EACE;IACE,eAAe;IACf,eAAe;IACf,eAAe;IACf,eAAe;IACf,eAAe;IACf,kBAAkB;IAClB,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;IACzB,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,eAAe;IACf,eAAe;IACf,eAAe;IACf,eAAe;IACf,eAAe;IACf,kBAAkB;IAClB,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;IACzB,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,eAAe;IACf,eAAe;IACf,eAAe;IACf,eAAe;IACf,eAAe;IACf,kBAAkB;IAClB,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;IACzB,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,eAAe;IACf,eAAe;IACf,eAAe;IACf,eAAe;IACf,eAAe;IACf,kBAAkB;IAClB,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;IACzB,uBAAuB;EACzB;AACF;;AAEA,mBAAmB;AACnB;EACE;IACE,yBAAyB;EAC3B;;EAEA;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;;IAEE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,iCAAiC;EACnC;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;;IAEE,yBAAyB;EAC3B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,mCAAmC;EACrC;AACF;;AAEA,iEAAiE;AACjE;EACE;;;;;IAKE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,kEAAkE;AAClE;EACE;;;IAGE,qCAAqC;IACrC,uCAAuC;IACvC,sCAAsC;IACtC,gCAAgC;EAClC;AACF","sourcesContent":[":root {\n  /* Color Tokens */\n  --technum-navy: #001F3F;\n  --technum-steel: #4B5563;\n  --technum-teal: #00A896;\n  --technum-pearl: #F0F4F8;\n  --technum-white: #FFFFFF;\n\n  --technum-success: #059669;\n  --technum-warning: #F59E0B;\n  --technum-error: #DC2626;\n\n  /* Additional Colors */\n  --technum-cream: #FAF7F2;\n  --technum-ink: #1F2937;\n  --technum-teal-hover: #008573;\n  --technum-gray-100: #F3F4F6;\n  --technum-gray-200: #E5E7EB;\n  --technum-gray-300: #D1D5DB;\n  --technum-gray-400: #9CA3AF;\n  --technum-accent-light: rgba(0, 168, 150, 0.1);\n  --technum-accent-medium: rgba(0, 168, 150, 0.2);\n  --technum-overlay-dark: rgba(0, 31, 63, 0.5);\n  --technum-gradient-start: #00D4AA;\n  --technum-dark-bg: #0A2540;\n  --technum-navy-hover: #001533;\n  --technum-steel-hover: #3B4653;\n  --technum-blue: #3B82F6;\n  --technum-cloud-blue: #4A90E2;\n\n  /* Extended Gray Palette */\n  --technum-gray-500: #6B7280;\n  --technum-gray-600: #4B5563;\n  --technum-gray-700: #374151;\n  --technum-gray-800: #1F2937;\n  --technum-gray-900: #111827;\n\n  /* Semantic Color Aliases */\n  --technum-amber: #F59E0B;\n  --technum-red: #DC2626;\n  --technum-green: #059669;\n\n  /* AWS Partner Colors */\n  --technum-aws-orange: #FF9900;\n  --technum-aws-orange-light: #FFB84D;\n  --technum-aws-orange-dark: #e68a00;\n  --technum-aws-dark: #232f3e;\n  --technum-aws-navy: #0a1628;\n  --technum-aws-mid: #1a2744;\n\n  /* Gradients */\n  --technum-gradient-teal: linear-gradient(135deg, #00A896 0%, #007B67 100%);\n  --technum-gradient-hero: linear-gradient(\n    135deg,\n    #001F3F 0%,\n    #002A5C 25%,\n    #00A896 75%,\n    #00C4A7 100%\n  );\n\n  /* Typography */\n  --font-heading: 'Inter', sans-serif;\n  --font-body: 'Roboto', sans-serif;\n  --font-code: 'JetBrains Mono', monospace;\n\n  --h1-size: 56px;\n  --h2-size: 48px;\n  --h3-size: 36px;\n  --h4-size: 28px;\n  --h5-size: 22px;\n  --body-large: 18px;\n  --body-regular: 16px;\n  --body-small: 14px;\n  --caption: 12px;\n  --btn-size: 16px;\n  --container-padding: 24px;\n  --section-padding: 80px;\n\n  --line-height-h1: 1.1;\n  --line-height-h2: 1.2;\n  --line-height-h3: 1.3;\n\n  /* Spacing */\n  --space-xxs: 2px;\n  --space-xs: 4px;\n  --space-sm: 8px;\n  --space-md: 16px;\n  --space-lg: 24px;\n  --space-xl: 40px;\n  --space-xxl: 64px;\n  --technum-space-xs: 4px;\n  --technum-space-sm: 8px;\n  --technum-space-md: 16px;\n  --technum-space-lg: 24px;\n  --technum-space-xl: 32px;\n  --technum-space-2xl: 48px;\n  --technum-space-3xl: 64px;\n\n  /* Border Radius */\n  --radius-sm: 4px;\n  --radius-md: 8px;\n  --radius-lg: 16px;\n  --radius-xl: 20px;\n  --radius-pill: 9999px;\n  --radius-circle: 50%;\n  --technum-radius-sm: 4px;\n  --technum-radius-md: 8px;\n  --technum-radius-lg: 12px;\n  --technum-radius-xl: 16px;\n  --technum-radius-2xl: 24px;\n  --technum-radius-full: 9999px;\n\n  /* Shadows */\n  --shadow-sm: 0 1px 2px rgba(0, 0, 0, 0.05);\n  --shadow-md: 0 4px 6px rgba(0, 0, 0, 0.1);\n  --shadow-lg: 0 8px 24px rgba(0, 0, 0, 0.15);\n  --shadow-xl: 0 12px 48px rgba(0, 0, 0, 0.2);\n\n  /* Homepage Shadow Variants */\n  --technum-shadow-sm: 0 1px 2px 0 rgba(0, 0, 0, 0.05);\n  --technum-shadow-md: 0 4px 6px -1px rgba(0, 0, 0, 0.1),\n    0 2px 4px -1px rgba(0, 0, 0, 0.06);\n  --technum-shadow-lg: 0 10px 15px -3px rgba(0, 0, 0, 0.1),\n    0 4px 6px -2px rgba(210, 55, 55, 0.05);\n  --technum-shadow-xl: 0 20px 25px -5px rgba(0, 0, 0, 0.1),\n    0 10px 10px -5px rgba(0, 0, 0, 0.04);\n\n  /* Transitions */\n  --transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  --transition-slow: all 0.6s cubic-bezier(0.4, 0, 0.2, 1);\n  --transition-fast: all 0.2s ease;\n}\n\n/* Global Page Styles */\nbody {\n  font-family: var(--font-body);\n  line-height: 1.6;\n  color: var(--technum-steel);\n  background-color: var(--technum-pearl);\n  scroll-behavior: smooth;\n  min-height: 100vh;\n  overflow-x: hidden;\n}\n\n/* Eliminate trailing whitespace between the last page section and the footer */\n.technumopus-main {\n  margin-bottom: 0;\n  padding-bottom: 0;\n}\n\n.technumopus-main > div,\n.technumopus-main > div > main {\n  margin-bottom: 0;\n  padding-bottom: 0;\n}\n\n.technumopus-main > div > section:last-of-type,\n.technumopus-main > div > main > section:last-of-type {\n  margin-bottom: 0;\n}\n\n/* Common Components */\n\n/* Container */\n.technum-container {\n  max-width: 1440px;\n  margin: 0 auto;\n  padding: 0 var(--container-padding);\n}\n\n/* Breadcrumb */\n.technum-breadcrumb {\n  background: var(--technum-white);\n  padding: var(--space-sm) 0;\n  border-bottom: 1px solid var(--technum-gray-200);\n}\n\n.technum-breadcrumb-nav {\n  display: flex;\n  align-items: center;\n  gap: var(--space-sm);\n  font-size: var(--body-small);\n}\n\n.technum-breadcrumb-nav a {\n  color: var(--technum-steel);\n  text-decoration: none;\n  transition: var(--transition);\n  position: relative;\n}\n\n.technum-breadcrumb-nav a::after {\n  content: '';\n  position: absolute;\n  bottom: -2px;\n  left: 0;\n  width: 0;\n  height: 2px;\n  background: var(--technum-teal);\n  transition: var(--transition);\n}\n\n.technum-breadcrumb-nav a:hover {\n  color: var(--technum-teal);\n}\n\n.technum-breadcrumb-nav a:hover::after {\n  width: 100%;\n}\n\n.technum-breadcrumb-nav span {\n  color: var(--technum-navy);\n  font-weight: 600;\n}\n\n/* Buttons */\n.technum-btn-primary {\n  background: var(--technum-teal);\n  color: var(--technum-white);\n  padding: var(--space-sm) var(--space-lg);\n  border: none;\n  border-radius: var(--radius-md);\n  font-family: var(--font-heading);\n  font-weight: 600;\n  font-size: var(--body-regular);\n  text-decoration: none;\n  transition: var(--transition);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  position: relative;\n  overflow: hidden;\n}\n\n.technum-btn-primary::before {\n  content: '';\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  width: 0;\n  height: 0;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.2);\n  transform: translate(-50%, -50%);\n  transition: width 0.6s, height 0.6s;\n}\n\n.technum-btn-primary:hover::before {\n  width: 300px;\n  height: 300px;\n}\n\n.technum-btn-primary:hover {\n  background: var(--technum-teal-hover);\n  transform: translateY(-2px);\n  box-shadow: 0 8px 20px var(--technum-accent-medium);\n}\n\n.technum-btn-secondary {\n  background: var(--technum-white);\n  color: var(--technum-navy);\n  padding: var(--space-sm) var(--space-lg);\n  border: 2px solid var(--technum-navy);\n  border-radius: var(--radius-md);\n  font-family: var(--font-heading);\n  font-weight: 600;\n  font-size: var(--body-regular);\n  text-decoration: none;\n  transition: var(--transition);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n}\n\n.technum-btn-secondary:hover {\n  background: var(--technum-pearl);\n  transform: translateY(-2px);\n  box-shadow: var(--shadow-sm);\n}\n\n.technum-btn-ghost {\n  background: transparent;\n  color: var(--technum-teal);\n  padding: var(--space-sm) var(--space-lg);\n  border: 2px solid var(--technum-teal);\n  border-radius: var(--radius-md);\n  font-family: var(--font-heading);\n  font-weight: 600;\n  font-size: var(--body-regular);\n  text-decoration: none;\n  transition: var(--transition);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n}\n\n.technum-btn-ghost:hover {\n  background: var(--technum-accent-light);\n  transform: translateY(-2px);\n  box-shadow: var(--shadow-sm);\n}\n\n.technum-btn-filter {\n  background: var(--technum-pearl);\n  color: var(--technum-steel);\n  padding: var(--space-sm) var(--space-lg);\n  border: 2px solid transparent;\n  border-radius: var(--radius-pill);\n  font-family: var(--font-heading);\n  font-weight: 500;\n  font-size: var(--body-small);\n  transition: var(--transition);\n  cursor: pointer;\n}\n\n.technum-btn-filter:hover,\n.technum-btn-filter.active {\n  background: var(--technum-teal);\n  color: var(--technum-white);\n  border-color: var(--technum-teal);\n}\n\n/* Hero Sections */\n.technum-hero {\n  padding: var(--section-padding) 0;\n  position: relative;\n  overflow: hidden;\n  text-align: center;\n}\n\n.technum-hero-content {\n  position: relative;\n  z-index: 2;\n  max-width: 900px;\n  margin: 0 auto;\n}\n\n.technum-hero h1 {\n  font-family: var(--font-heading);\n  font-weight: 700;\n  font-size: var(--h1-size);\n  margin-bottom: var(--space-lg);\n  line-height: var(--line-height-h1);\n  letter-spacing: -0.02em;\n}\n\n.technum-hero p {\n  font-size: var(--body-large);\n  max-width: 700px;\n  margin: 0 auto var(--space-xl);\n  line-height: 1.7;\n}\n\n.technum-hero-buttons {\n  display: flex;\n  gap: var(--space-md);\n  flex-wrap: wrap;\n  justify-content: center;\n}\n\n/* Hero Type 1: Gradient Background */\n.technum-hero-gradient {\n  background: linear-gradient(135deg, var(--technum-navy) 0%, var(--technum-teal) 100%);\n  color: var(--technum-white);\n}\n\n.technum-hero-gradient h1,\n.technum-hero-gradient p {\n  color: var(--technum-white);\n}\n\n.technum-hero-gradient::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: radial-gradient(circle at 20% 50%, var(--technum-accent-light) 0%, transparent 50%);\n  opacity: 0.6;\n}\n\n/* Hero Type 2: Image Background */\n.technum-hero-image {\n  background-size: cover;\n  background-position: center;\n  color: var(--technum-white);\n}\n\n.technum-hero-image::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: var(--technum-overlay-dark);\n}\n\n.technum-hero-image h1,\n.technum-hero-image p {\n  color: var(--technum-white);\n}\n\n/* Card Sections */\n.technum-card {\n  background: var(--technum-white);\n  border: 1px solid var(--technum-gray-200);\n  border-radius: var(--radius-lg);\n  padding: var(--space-xl);\n  transition: var(--transition);\n  position: relative;\n  overflow: hidden;\n}\n\n.technum-card:hover {\n  border-color: var(--technum-teal);\n  transform: translateY(-4px);\n  box-shadow: var(--shadow-lg);\n}\n\n.technum-card h3 {\n  font-family: var(--font-heading);\n  font-weight: 600;\n  font-size: var(--h4-size);\n  color: var(--technum-navy);\n  margin-bottom: var(--space-md);\n}\n\n.technum-card p {\n  font-size: var(--body-regular);\n  color: var(--technum-steel);\n  line-height: 1.7;\n}\n\n/* Card Type 1: Icon Feature Card (e.g., benefits, culture) */\n.technum-card-feature {\n  text-align: center;\n}\n\n.technum-card-feature-icon {\n  width: 64px;\n  height: 64px;\n  background: var(--technum-accent-light);\n  border: 2px solid var(--technum-teal);\n  border-radius: var(--radius-md);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0 auto var(--space-lg);\n  color: var(--technum-teal);\n  transition: var(--transition);\n  font-size: 32px;\n}\n\n.technum-card-feature:hover .technum-card-feature-icon {\n  background: var(--technum-teal);\n  color: var(--technum-white);\n  transform: scale(1.05) rotate(5deg);\n}\n\n/* Dark variant for feature card */\n.technum-card-feature-dark {\n  background: var(--technum-accent-medium);\n  color: var(--technum-white);\n  border-color: var(--technum-accent-medium);\n}\n\n.technum-card-feature-dark h3 {\n  color: var(--technum-white);\n}\n\n.technum-card-feature-dark p {\n  color: rgba(255, 255, 255, 0.9);\n}\n\n.technum-card-feature-dark .technum-card-feature-icon {\n  background: rgba(255, 255, 255, 0.1);\n  border-color: rgba(255, 255, 255, 0.3);\n  color: var(--technum-white);\n}\n\n.technum-card-feature-dark:hover .technum-card-feature-icon {\n  background: var(--technum-teal);\n  border-color: var(--technum-teal);\n}\n\n/* Card Type 2: Metric/Stat Card */\n.technum-card-metric {\n  text-align: center;\n  padding: var(--space-lg);\n}\n\n.technum-card-metric-icon {\n  width: 80px;\n  height: 80px;\n  background: linear-gradient(135deg, var(--technum-teal), var(--technum-navy));\n  border-radius: var(--radius-circle);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0 auto var(--space-lg);\n  color: var(--technum-white);\n  font-size: 40px;\n}\n\n.technum-card-metric-value {\n  font-family: var(--font-heading);\n  font-weight: 700;\n  font-size: 32px;\n  color: var(--technum-teal);\n  margin-bottom: var(--space-sm);\n}\n\n.technum-card-metric-label {\n  font-size: var(--body-small);\n  color: var(--technum-steel);\n  font-weight: 500;\n}\n\n.technum-card-metric-description {\n  font-size: var(--body-small);\n  color: var(--technum-steel);\n  opacity: 0.8;\n  margin-top: var(--space-xs);\n}\n\n/* Card Type 3: Content Card with Image/Gradient Header */\n.technum-card-content {\n  overflow: hidden;\n}\n\n.technum-card-content-header {\n  width: 100%;\n  height: 200px;\n  background: linear-gradient(135deg, var(--technum-teal), var(--technum-navy));\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  transition: var(--transition);\n}\n\n.technum-card-content-header::after {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: linear-gradient(45deg, transparent 30%, rgba(255,255,255,0.1) 50%, transparent 70%);\n  transform: translateX(-100%);\n  transition: transform 0.6s ease;\n}\n\n.technum-card-content:hover .technum-card-content-header::after {\n  transform: translateX(100%);\n}\n\n.technum-card-content-header-icon {\n  width: 80px;\n  height: 80px;\n  color: var(--technum-white);\n  opacity: 0.9;\n}\n\n.technum-card-content-body {\n  padding: var(--space-lg);\n}\n\n.technum-card-content-meta {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: var(--space-sm);\n  font-size: var(--caption);\n  color: var(--technum-steel);\n}\n\n.technum-card-content-category {\n  background: var(--technum-pearl);\n  padding: var(--space-xs) var(--space-sm);\n  border-radius: var(--radius-md);\n  font-weight: 500;\n}\n\n/* Sections */\n.technum-section {\n  padding: var(--section-padding) 0;\n}\n\n.technum-section-header {\n  text-align: center;\n  margin-bottom: var(--space-xxl);\n}\n\n.technum-section-header h2 {\n  font-family: var(--font-heading);\n  font-weight: 600;\n  font-size: var(--h2-size);\n  color: var(--technum-navy);\n  margin-bottom: var(--space-md);\n  letter-spacing: -0.01em;\n}\n\n.technum-section-header p {\n  font-size: var(--body-large);\n  color: var(--technum-steel);\n  max-width: 720px;\n  margin: 0 auto;\n  line-height: 1.7;\n}\n\n/* Dark section variant */\n.technum-section-dark {\n  background: var(--technum-dark-bg);\n  color: var(--technum-white);\n}\n\n.technum-section-dark .technum-section-header h2 {\n  color: var(--technum-white);\n}\n\n.technum-section-dark .technum-section-header p {\n  color: rgba(255, 255, 255, 0.9);\n}\n\n/* Grid Layouts */\n.technum-grid-2 {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: var(--space-xl);\n}\n\n.technum-grid-3 {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\n  gap: var(--space-lg);\n}\n\n.technum-grid-4 {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: var(--space-md);\n}\n\n.technum-grid-auto {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n  gap: var(--space-lg);\n}\n\n/* Form Elements (Generic) */\n.technum-form-group {\n  margin-bottom: var(--space-lg);\n}\n\n.technum-form-group label {\n  display: block;\n  margin-bottom: var(--space-sm);\n  font-family: var(--font-heading);\n  font-weight: 500;\n  color: var(--technum-navy);\n  font-size: var(--body-small);\n}\n\n.technum-form-group input,\n.technum-form-group select,\n.technum-form-group textarea {\n  width: 100%;\n  padding: var(--space-sm) var(--space-md);\n  border: 2px solid var(--technum-gray-200);\n  border-radius: var(--radius-md);\n  font-family: var(--font-body);\n  font-size: var(--body-regular);\n  transition: var(--transition);\n  background: var(--technum-white);\n  box-sizing: border-box;\n}\n\n.technum-form-group input:focus,\n.technum-form-group select:focus,\n.technum-form-group textarea:focus {\n  outline: none;\n  border-color: var(--technum-teal);\n  box-shadow: 0 0 0 4px var(--technum-accent-light);\n}\n\n.technum-form-group textarea {\n  min-height: 120px;\n  resize: vertical;\n}\n\n/* Search Input */\n.technum-search-input {\n  display: flex;\n  align-items: center;\n  background: var(--technum-pearl);\n  padding: var(--space-sm) var(--space-md);\n  border-radius: var(--radius-md);\n  border: 2px solid transparent;\n  transition: var(--transition);\n  max-width: 300px;\n}\n\n.technum-search-input:focus-within {\n  border-color: var(--technum-teal);\n}\n\n.technum-search-input input {\n  background: none;\n  border: none;\n  outline: none;\n  font-family: var(--font-body);\n  font-size: var(--body-regular);\n  color: var(--technum-steel);\n  flex: 1;\n  margin-left: var(--space-sm);\n}\n\n.technum-search-input input::placeholder {\n  color: var(--technum-gray-400);\n}\n\n/* Tags and Badges */\n.technum-tag {\n  display: inline-flex;\n  align-items: center;\n  padding: var(--space-xs) var(--space-sm);\n  border-radius: var(--radius-pill);\n  font-size: var(--caption);\n  font-weight: 500;\n  background: var(--technum-pearl);\n  color: var(--technum-steel);\n}\n\n.technum-tag-primary {\n  background: var(--technum-teal);\n  color: var(--technum-white);\n}\n\n.technum-tag-warning {\n  background: var(--technum-accent-light);\n  color: var(--technum-warning);\n}\n\n.technum-tag-success {\n  background: var(--technum-success);\n  color: var(--technum-white);\n}\n\n.technum-badge {\n  display: inline-flex;\n  align-items: center;\n  padding: 6px 16px;\n  border-radius: var(--radius-pill);\n  font-size: var(--caption);\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.technum-badge-primary {\n  background: var(--technum-teal);\n  color: var(--technum-white);\n}\n\n.technum-badge-light {\n  background: var(--technum-accent-medium);\n  color: var(--technum-white);\n}\n\n/* Icons (Common styles) */\n.technum-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--technum-teal);\n  transition: var(--transition);\n}\n\n.technum-icon-small {\n  font-size: 16px;\n}\n\n.technum-icon-medium {\n  font-size: 24px;\n}\n\n.technum-icon-large {\n  font-size: 40px;\n}\n\n.technum-icon-circle {\n  background: var(--technum-accent-light);\n  border-radius: var(--radius-circle);\n  padding: var(--space-xs);\n}\n\n.technum-icon-rounded {\n  background: var(--technum-teal);\n  color: var(--technum-white);\n  border-radius: var(--radius-md);\n  padding: var(--space-sm);\n}\n\n.technum-icon:hover {\n  transform: scale(1.1);\n}\n\n/* Read More Link */\n.technum-read-more {\n  color: var(--technum-teal);\n  text-decoration: none;\n  font-family: var(--font-heading);\n  font-weight: 600;\n  display: inline-flex;\n  align-items: center;\n  gap: var(--space-sm);\n  transition: var(--transition);\n}\n\n.technum-read-more:hover {\n  color: var(--technum-teal-hover);\n  gap: var(--space-md);\n}\n\n/* Animations */\n@keyframes technum-fade-in {\n  from { opacity: 0; transform: translateY(20px); }\n  to { opacity: 1; transform: translateY(0); }\n}\n\n.technum-animate-fade {\n  animation: technum-fade-in var(--transition-slow);\n}\n\n/* ── Responsive Typography & Spacing Variables ── */\n@media (max-width: 1024px) {\n  :root {\n    --h1-size: 44px;\n    --h2-size: 36px;\n    --h3-size: 28px;\n    --h4-size: 24px;\n    --h5-size: 20px;\n    --body-large: 16px;\n    --body-regular: 15px;\n    --body-small: 14px;\n    --btn-size: 14px;\n    --container-padding: 20px;\n    --section-padding: 64px;\n  }\n}\n\n@media (max-width: 768px) {\n  :root {\n    --h1-size: 36px;\n    --h2-size: 30px;\n    --h3-size: 24px;\n    --h4-size: 20px;\n    --h5-size: 18px;\n    --body-large: 15px;\n    --body-regular: 14px;\n    --body-small: 13px;\n    --btn-size: 13px;\n    --container-padding: 16px;\n    --section-padding: 48px;\n  }\n}\n\n@media (max-width: 480px) {\n  :root {\n    --h1-size: 28px;\n    --h2-size: 24px;\n    --h3-size: 20px;\n    --h4-size: 18px;\n    --h5-size: 16px;\n    --body-large: 14px;\n    --body-regular: 14px;\n    --body-small: 13px;\n    --btn-size: 12px;\n    --container-padding: 14px;\n    --section-padding: 36px;\n  }\n}\n\n@media (max-width: 360px) {\n  :root {\n    --h1-size: 24px;\n    --h2-size: 22px;\n    --h3-size: 18px;\n    --h4-size: 16px;\n    --h5-size: 14px;\n    --body-large: 14px;\n    --body-regular: 13px;\n    --body-small: 12px;\n    --btn-size: 12px;\n    --container-padding: 12px;\n    --section-padding: 28px;\n  }\n}\n\n/* Responsiveness */\n@media (max-width: 1100px) {\n  .technum-hero h1 {\n    font-size: var(--h1-size);\n  }\n\n  .technum-grid-4 {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n@media (max-width: 900px) {\n  .technum-grid-2,\n  .technum-grid-3 {\n    grid-template-columns: 1fr;\n  }\n\n  .technum-form-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (max-width: 720px) {\n  .technum-section {\n    padding: var(--section-padding) 0;\n  }\n\n  .technum-hero {\n    padding: var(--space-xl) 0;\n  }\n\n  .technum-hero h1,\n  .technum-section-header h2 {\n    font-size: var(--h2-size);\n  }\n\n  .technum-grid-4 {\n    grid-template-columns: 1fr;\n  }\n\n  .technum-container {\n    padding: 0 var(--container-padding);\n  }\n}\n\n/* ---------- Touch Device: disable hover transforms ---------- */\n@media (hover: none) {\n  .technum-btn-primary:hover,\n  .technum-btn-secondary:hover,\n  .technum-btn-ghost:hover,\n  .technum-card:hover,\n  .technum-icon:hover {\n    transform: none;\n  }\n\n  .technum-card-feature:hover .technum-card-feature-icon {\n    transform: none;\n  }\n}\n\n/* ---------- Reduced Motion: respect user preference ---------- */\n@media (prefers-reduced-motion: reduce) {\n  *,\n  *::before,\n  *::after {\n    animation-duration: 0.01ms !important;\n    animation-iteration-count: 1 !important;\n    transition-duration: 0.01ms !important;\n    scroll-behavior: auto !important;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
